import * as z from "zod";

export const LSJobAccessorySchema = z.object({
	code: z.string(),
	amount: z.coerce.number(),
	name: z.string().optional(),
});
export type LSJobAccessory = z.infer<typeof LSJobAccessorySchema>;

export const LSJobAccessorySelectionSchema = LSJobAccessorySchema.pick({
	code: true,
	amount: true,
});
export type LSJobAccessorySelection = z.infer<typeof LSJobAccessorySelectionSchema>;
